module.exports = {
  EXECNET: 'execnet',
  NOVACOOP: 'nova-coop',
  CONEXAOSAUDE: 'conexaosaude',
};
